export default __webpack_public_path__ + "static/media/JATM.bf46e1c8.png";